module.exports = __webpack_public_path__ + "static/media/k12_business-card_front_2x.3682de21.jpg";